var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRariChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.19982V3.8451C0 2.82608 1.02335 2 2.28571 2H6.44157C7.70394 2 8.72729 2.82608 8.72729 3.8451V6.55416C8.72729 7.02127 8.95715 7.46924 9.36633 7.79954C10.2184 8.48735 11.5998 8.48735 12.4519 7.79954L18.9669 2.54042C19.3956 2.19439 19.9769 2 20.5832 2H21.7143C22.9767 2 24 2.82608 24 3.8451V4.7582C24 5.24755 23.7592 5.71686 23.3305 6.06288L16.8155 11.322C15.9635 12.0098 15.9635 13.1249 16.8155 13.8127C17.2247 14.1431 17.7797 14.3286 18.3583 14.3286H21.7143C22.9767 14.3286 24 15.1547 24 16.1737V19.5284C24 20.5474 22.9767 21.3735 21.7143 21.3735H17.5585C16.2961 21.3735 15.2728 20.5474 15.2728 19.5284V16.8194C15.2728 16.3522 15.0428 15.9042 14.6337 15.574C13.7816 14.8862 12.4002 14.8862 11.5482 15.574L5.03312 20.8331C4.60446 21.1791 4.02308 21.3735 3.41687 21.3735H2.28572C1.02335 21.3735 0 20.5474 0 19.5284V18.6153C0 18.126 0.240816 17.6566 0.669472 17.3106L7.18451 12.0515C8.03656 11.3637 8.03656 10.2486 7.18451 9.56077C6.77534 9.23048 6.22038 9.04492 5.64172 9.04492H2.28572C1.02335 9.04492 0 8.21884 0 7.19982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRariChain);
export default __webpack_public_path__ + "static/media/rari-chain.9beb681530af837d41d82009328e5951.svg";
export { ForwardRef as ReactComponent };